import { services } from '@/utils'

import sourceBox from '@/components/source/box'

export default function(h) {
  return h(
    'div',
    {
      class: `${services.sendings}-item__tabs-source`
    },
    [
      h(
        sourceBox,
        {
          props: { value: this.value }
        }
      )
    ]
  )
}
